import * as React from 'react'
import { ComponentProps, useState } from 'react'
import { RadioSelect } from '../RadioSelect/RadioSelect'
import { formatTimeline, isTimelinePresetOption } from '../../../utils/date'
import { useTimelineLabels } from './useTimelineSelectOptions'
import { TimelinePresetOption } from '../Filter/types'
import { getTimelineValue } from '../Filter/TimelineFilter/utils'
import { useDropdownClickOutside } from '../Dropdown/useDropdownClickOutside'

type TimelineSelectProps = {
    name: string
    value: TimelinePresetOption
    onChange?: (timeline: TimelinePresetOption) => void
    wrapperClassname?: string
    buttonWrapperClassname?: string
    buttonClassname?: string
    dropdownClassname?: string
}

export const TimelineSelect: React.FC<TimelineSelectProps> = (props) => {
    const { onChange, name } = props
    const labelsMap = useTimelineLabels()
    const options = Object.keys(labelsMap).map((labelKey) => ({
        value: labelKey,
        label: labelsMap[labelKey as keyof typeof labelsMap],
    }))
    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState<TimelinePresetOption>(props.value)

    const renderLabel: ComponentProps<typeof RadioSelect>['renderLabel'] = (
        option
    ) => {
        if (
            typeof option.value !== 'string' ||
            !isTimelinePresetOption(option.value)
        ) {
            return <>{option.label}</>
        }

        const value = getTimelineValue(option.value)

        return (
            <>
                <div className="text-label-small text-regular">
                    {option.label}
                </div>
                <div className="text-body-medium whitespace-nowrap text-subtle">
                    {formatTimeline({
                        startDate: value.startDate,
                        endDate: value.endDate,
                    })}
                </div>
            </>
        )
    }

    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        setIsOpen(false)
    })

    return (
        <RadioSelect
            name={name}
            isOpen={isOpen}
            renderLabel={renderLabel}
            onClick={() => {
                setIsOpen((isOpen) => !isOpen)
            }}
            options={options}
            value={value}
            onChange={(value) => {
                if (
                    typeof value === 'string' &&
                    isTimelinePresetOption(value)
                ) {
                    setValue(value)
                    onChange?.(value)
                    setIsOpen(false)
                }
            }}
            wrapperClassname={props.wrapperClassname}
            buttonWrapperClassname={props.buttonWrapperClassname}
            buttonClassname={props.buttonClassname}
            dropdownClassname={props.dropdownClassname}
            matchReferenceWidth={true}
            dropdownRef={dropdownRef}
            buttonRef={buttonRef}
        />
    )
}
